import { useEffect } from 'react'

const PluginAuthSuccess = () => {
  useEffect(() => {
    // Try to close the window after a short delay
    const timer = setTimeout(() => {
      try {
        window.close()
      } catch {
        // window.close() may not work if the page wasn't opened by script
      }
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className='min-h-screen bg-[#F5F5F5] flex items-center justify-center'>
      <div className='bg-white rounded-[24px] p-8 max-w-[400px] w-full text-center relative'>
        <div className='flex flex-col gap-6 items-center'>
          <div className='w-12 h-12 rounded-full bg-[#f0fdf4] flex items-center justify-center'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M20 6L9 17L4 12'
                stroke='#16a34a'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <h1 className='font-bold text-[20px] leading-[22px] text-[rgba(0,0,0,0.88)]'>
            Authentication Successful
          </h1>
          <p className='text-[15px] leading-[22px] text-[rgba(0,0,0,0.55)]'>
            You can close this window and return to your IDE.
          </p>
        </div>
        <div className='absolute border border-[#eaeaea] border-solid inset-0 pointer-events-none rounded-[24px]' />
      </div>
    </div>
  )
}

const Page = () => <PluginAuthSuccess />

export default Page
